export default {
      id: "icon-date-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-date",
      toString: function () {
        return this.url;
      }
    }